export const PROPERTY_PERMISSIONS = {
  USE_E_REGISTRATION_CARD_APPLICATION: {
    id: '1dafdaaa-ce5d-4b58-83ed-1e6a5792ee9f',
    isRequired: true,
  },
};
